export const offerings = [
  {
    imgSrc: "/Services/online-store.png",
    imgAlt: "Smart Retail Solution",
    heading: "Website Development",
    description:
      "Get a professionally designed, SEO-optimized website that works seamlessly across all devices. From portfolio sites to eCommerce platforms and fully customized web applications, we develop responsive websites tailored to your brand and business goals.",
  },
  {
    imgSrc: "/Services/smartphone.png",
    imgAlt: "Visual Merchandise",
    heading: "Mobile App Development",
    description:
      "We develop powerful and user-friendly mobile apps for Android and iOS. Our mobile app development services focus on performance, intuitive UX/UI design, and feature-rich functionality to help you grow and engage your user base effectively.",
  },
  {
    imgSrc: "/Services/whatsapp.png",
    imgAlt: "Innovation Centre",
    heading: "WhatsApp Marketing",
    description:
      "Enhance your marketing strategy with WhatsApp Marketing automation. Send bulk messages, schedule campaigns, and engage your audience in real time through a trusted and widely used platform. Perfect for customer support, promotions, and lead generation.",
  },
  {
    imgSrc: "/Services/software-development.png",
    imgAlt: "Software & Content",
    heading: "Custom Software Development",
    description:
      "Streamline your business operations with our custom software development services. We build tailored CRM systems and business tools to automate workflows, improve lead management, and increase operational efficiency for long-term growth.",
  },
];

export const solutions = [
  {
    icon: "/Services/online-store.png",
    title: "Website Development (Portfolio, E-commerce, Custom Websites)",
    description:
      "Boost your online presence with our expert website development services. We build fast, mobile-responsive, and SEO-friendly websites—perfect for portfolios, online stores, or fully custom business platforms.",
    services: [
      {
        heading: "Portfolio Websites",
        description:
          "Showcase your work with beautifully crafted, lightning-fast websites.",
      },
      {
        heading: "E-commerce Websites",
        description:
          "Launch a secure online store with powerful product management and payment integrations.",
      },
      {
        heading: "Custom Websites",
        description:
          "Get fully personalized web solutions tailored to meet your business goals.",
      },
    ],
    ld: "Our websites are optimized for performance, mobile responsiveness, and search engine visibility, ensuring you stand out in a crowded digital landscape.",
  },
  {
    icon: "/Services/smartphone.png",
    title: "Mobile App Development",
    description:
      "Stay ahead in the mobile-first era with our custom mobile app development services. We build high-performance apps for Android and iOS that deliver smooth user experiences and business value.",
    services: [
      {
        heading: "Custom App Development",
        description:
          "Bespoke mobile applications designed for unique business workflows and user needs.",
      },
      {
        heading: "Cross-Platform Apps",
        description:
          "Save time and cost with apps built for both Android and iOS platforms.",
      },
      {
        heading: "User-Centric Design",
        description: "Intuitive UI/UX designs that keep your audience engaged.",
      },
    ],
    ld: "Our mobile apps are built to scale, ensuring a seamless user experience that enhances customer satisfaction and retention.",
  },
  {
    icon: "/Services/whatsapp.png",
    title: "WhatsApp Marketing",
    description:
      "Reach your audience directly with our powerful WhatsApp Marketing solutions. Run personalized campaigns, automate responses, and engage customers on a platform they already trust.",
    services: [
      {
        heading: "Bulk Messaging",
        description:
          "Send updates, promotions, and announcements to thousands of users instantly.",
      },
      {
        heading: "Personalized Campaigns",
        description:
          "Segment your audience and send tailored messages that boost conversion rates.",
      },
    ],
    ld: "Leverage WhatsApp to improve communication, increase conversions, and grow your business with cost-effective, real-time messaging solutions.",
  },
  {
    icon: "/Services/crm.png",
    title: "Custom CRM Development",
    description:
      "Take control of customer relationships with our tailor-made CRM solutions. Streamline sales, manage leads efficiently, and automate routine tasks to maximize productivity.",
    services: [
      {
        heading: "Lead Management",
        description:
          "Capture, track, and convert leads with a powerful and intuitive CRM system.",
      },
      {
        heading: "Sales Automation",
        description:
          "Automate your sales process to close deals faster and smarter.",
      },
      {
        heading: "Custom Dashboards",
        description:
          "Visualize real-time business insights through personalized dashboards.",
      },
    ],
    ld: "Our custom CRMs are scalable and feature-rich, helping you build stronger customer relationships and increase operational efficiency.",
  },
  {
    icon: "/Services/bill.png",
    title: "POS-Based Billing Software",
    description:
      "Simplify your sales and inventory operations with our smart POS-based billing software. Designed for retailers and service businesses, it helps you manage transactions, track stock, and generate real-time reports.",
    services: [
      {
        heading: "Inventory Management",
        description:
          "Monitor stock levels, avoid shortages, and optimize reordering.",
      },
      {
        heading: "Real-Time Sales Reporting",
        description: "View live sales analytics and improve decision-making.",
      },
      {
        heading: "Multi-Location Support",
        description:
          "Operate and monitor multiple branches from a single dashboard.",
      },
    ],
    ld: "Our POS software improves checkout efficiency, inventory control, and sales accuracy—perfect for growing businesses.",
  },
  {
    icon: "/Services/software-development.png",
    title: "Custom Software Development",
    description:
      "Empower your business with fully customized software solutions built to your exact needs. From process automation to complex enterprise applications, we deliver secure, scalable software tailored for growth.",
    services: [
      {
        heading: "Business Automation",
        description:
          "Replace manual tasks with efficient, automated workflows.",
      },
      {
        heading: "API Integrations",
        description:
          "Connect with third-party platforms and services seamlessly.",
      },
      {
        heading: "Custom Features",
        description:
          "Build specific tools and modules to suit your business logic.",
      },
    ],
    ld: "Our software solutions are engineered for reliability and growth, giving your business a technological edge in a competitive marketplace.",
  },
];

export const SERVICE_OFFERINGS = [
  {
    src: "/Services/online-store.png",
    alt: "Web-Development",
    text: "Web Development",
  },
  {
    src: "/Services/smartphone.png",
    alt: "Mobile App Development",
    text: "Mobile App Development",
  },
  {
    src: "/Services/whatsapp.png",
    alt: "WhatsApp Marketing",
    text: "WhatsApp Marketing",
  },
  {
    src: "/Services/crm.png",
    alt: "Custom CRM Development",
    text: "Custom CRM Development",
  },
  {
    src: "/Services/software-development.png",
    alt: "Custom Software Development",
    text: "Custom Software Development",
  },
];
